import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconArrowCircleRightComponent } from "./med-icon-arrow-circle-right.component";

@NgModule({
  declarations: [
    MedIconArrowCircleRightComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconArrowCircleRightComponent,
  ],
})
export class MedIconArrowCircleRightModule { }
